import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    formBox: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(5),
    },
    formContainer: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(4),
    },
    passwordContainer: {
        display: "flex",
        alignItems: "flex-end",
        flexDirection: "column",
        gap: theme.spacing(1),
    },
    forgotPasswordLink: {
        fontSize: 14,
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline",
        },
    },
    footerText: {
        fontSize: 16,
        color: theme.palette.text.primary,
        textAlign: "center",
    },
    signUpLink: {
        color: theme.palette.emteria.link,
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline",
        },
    },
}));
